// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import type { Rect } from '../../types'

interface GhostImageOverlayProps {
    src: string
    mediaType?: string
    rect: Rect
    opacity: number
}

export function GhostImageOverlay(props: GhostImageOverlayProps): ReactElement {
    const { src, rect, opacity, mediaType } = props

    if (mediaType === 'video') {
        return (
            <video
                src={src}
                muted
                loop
                autoPlay
                playsInline
                preload="metadata"
                draggable={false}
                style={{
                    position: 'absolute',
                    left: rect.x,
                    top: rect.y,
                    width: rect.w,
                    height: rect.h,
                    opacity,
                    pointerEvents: 'none',
                    objectFit: 'fill',
                    zIndex: 9999,
                    transition: 'opacity 0.15s ease-out',
                }}
                data-canvas-ui="true"
            />
        )
    }

    return (
        <img
            src={src}
            alt="dragging"
            loading="lazy"
            referrerPolicy="no-referrer"
            draggable={false}
            style={{
                position: 'absolute',
                left: rect.x,
                top: rect.y,
                width: rect.w,
                height: rect.h,
                opacity,
                pointerEvents: 'none',
                objectFit: 'fill',
                zIndex: 9999,
                transition: 'opacity 0.15s ease-out',
            }}
            data-canvas-ui="true"
        />
    )
}

